import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { HydraCollection } from '../hydra/hydra-collection';
import { map } from 'rxjs/operators';
import { OrganisationAddressModel } from '../models/organisation/organisation-address';


@Injectable({
  providedIn: 'root'
})
export class OrganisationAddressApiService extends ApiService {
  readonly resourcePath = 'organisation_addresses';

  list(filters: Record<string, string> = {}): Observable<HydraCollection<OrganisationAddressModel>> {
    return this.restList<OrganisationAddressModel>(filters);
  }

  get(id: string): Observable<OrganisationAddressModel> {
    return this.restRead<OrganisationAddressModel>(id);
  }

  update(id: string, data: object): Observable<OrganisationAddressModel> {
    return this.restUpdate<OrganisationAddressModel>(id, data);
  }

  create(data:object){
    return this.restCreate<OrganisationAddressModel>(data);
  }
  delete(id:string){
    return this.restDelete(id);
  }

  getAllByClient(orgId:string,clientId:string):Observable<HydraCollection<OrganisationAddressModel>> {
    return this.http.get<HydraCollection<OrganisationAddressModel>>(this.resourceUrl +'?organisation.client='+clientId+'&organisation.organisationProfile='+ orgId).pipe(
      map(response => new HydraCollection<OrganisationAddressModel>(response))
    );

  }
}
